module.exports = __webpack_public_path__ + "img/certificate-bj.ffe820ce.png";